import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const TwoFactorAuthenticationComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "TwoFactorAuthenticationPage" */ "@circle-react/components/OnboardingPage/EmailOtpVerificationPage"
    ),
);

export const TwoFactorAuthenticationPage = () => (
  <Suspense fallback={<PageLoader />}>
    <TwoFactorAuthenticationComponent />
  </Suspense>
);
